// extracted by css-extract-rspack-plugin
export default {"link":"_1795ef3","icon":"_10161898"};